import originAxios from "axios"
import toLogin from "@/libs/login";
import cookie from "@/utils/store/cookie";
export default function axios(option) {
  return new Promise((resolve, reject) => {
    // 1.创建axios的实例
    let odatal = localStorage.getItem("odata");
    var Content = 'text/html; charset=utf-8'
    if(odatal == 1){
        Content = 'application/x-www-form-urlencoded'
      }else{
        Content = 'text/html; charset=utf-8'
      }
    const instance = originAxios.create({
      baseURL: process.env.API_HOST,
      timeout: 8000,
      headers: {
        'Content-Type': Content
      }
    });
    // 配置请求和响应拦截

    instance.interceptors.request.use(config => {
      let token = localStorage.getItem("token");
      if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = token;
        config.headers.Token = token;
      }
      return config
    }, error => {
      // console.log(Promise.reject(error.response.data));
      return error.response.data.message;
    })

    instance.interceptors.response.use(
      response => {
        return response.data;
      },
      err => {
        if (err && err.response) {
          console.log(err.response.status)
          switch (err.response.status) {
            case 400:
              // err.message = "请求错误";
              return err.response.data;
            case 401:
              cookie.remove('wx_auth');
              toLogin(true, location.href)
              return Promise.reject(err.response.data)
          }
        }
        return err.response.data;
      }
    );

    // 2.传入对象进行网络请求
    instance(option)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        resolve(err);
      });
  });
}


// WEBPACK FOOTER //
// ./src/network/request.js